import './RegStepPopmenuAuth.scss';
import {Button} from "../account/misc/Button";
import {connectToPopmenu} from "../../service/PosService";
import PopmenuLogoLarge from "../icons/PopmenuLogoLarge";
import {memberState} from "../../state/atoms";
import {useRecoilValue} from "recoil";

interface RegStepPopmenuAuthProps {
  email: string;
}

export default function RegStepPopmenuAuth({email}: RegStepPopmenuAuthProps) {
  const member = useRecoilValue(memberState);

  return <div className={'pop-container step full'}>
    <PopmenuLogoLarge className={'logo'}/>
    <Button size={"Large"} className={"primary"} onClick={() => connectToPopmenu(true, email || member.email)}>Approve integration with Popmenu</Button>
  </div>
}
